import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const breakpoints = {
  tablet: 768,
  phone:  480,
};

const AnnouncementsBlock = styled.div`
  overflow: hidden;
  padding: 0;
  width: 100%;
  max-width: none;
  @media (max-width: ${breakpoints.phone}px) {
    max-width: 100%;
  }
`;

const AnnouncementsMenu = styled.div`
  margin-bottom: 20px;
`;

const SectionHeader = styled.div`
  font-size: 16px;
  // font-weight: bold;
  padding: 10px;
  margin-bottom: 0;
  border-radius: 5px 5px 0px 0px;
  color: white;
  background-color: ${(props) => props.colors.componentHeaderBackground};
`;

const AnnouncementList = styled.ul`
  list-style-type: none;
  padding: 10px;
  border-radius: 0px 0px 5px 5px;
  background-color: ${(props) => props.colors.formBackground};
  margin-top: 0;
`;

const AnnouncementItem = styled.li`
  margin-bottom: 8px;
  color: ${(props) => props.colors.buttonBackground};

  a {
    color: ${(props) => props.colors.buttonBackground};
    text-decoration: none;
    font-size: 14px;

    &:hover {
      text-decoration: underline;
    }
  }

  small {
    display: block;
    font-size: 12px;
    margin-top: 4px;
  }
`;

const AnnouncementPlaceholder = styled.li`
  color: ${(props) => props.colors.textSecondary};
  font-size: 14px;
  padding: 12px 0;
`;

const MAX_SNIPPET_LENGTH = 220;

const stripHtml = (html = "") =>
  html.replace(/<\/?[^>]+(>|$)/g, "").replace(/\s+/g, " ").trim();

const AnnouncementCard = ({ colors }) => {
  const announcements = useSelector((state) => state.auth.announcements);

  const topAnnouncements = useMemo(() => {
    if (!announcements?.length) return [];
    return announcements
      .slice()
      .sort((a, b) => {
        const dateA = new Date(a.announcement_date || a.inserted || 0).getTime();
        const dateB = new Date(b.announcement_date || b.inserted || 0).getTime();
        return dateB - dateA;
      })
      .slice(0, 3);
  }, [announcements]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const buildSnippet = (text) => {
    const clean = stripHtml(text || "");
    if (clean.length <= MAX_SNIPPET_LENGTH) return clean;
    return `${clean.slice(0, MAX_SNIPPET_LENGTH).trim()}…`;
  };

  return (
    <AnnouncementsBlock>
      <AnnouncementsMenu>
        <SectionHeader colors={colors}>Announcements</SectionHeader>
        <AnnouncementList colors={colors}>
          {topAnnouncements.length ? (
            topAnnouncements.map((announcement, index) => (
              <AnnouncementItem colors={colors} key={index}>
                <Link
                  to={`/admincentral/announcements/view/${announcement.announcement_id || announcement.id}`}
                  state={{ announcement }}
                >
                  <strong>{announcement.title}</strong>
                  <small>{formatDate(announcement.announcement_date || announcement.inserted)}</small>
                  <p>{buildSnippet(announcement.announcement || announcement.summary)}</p>
                </Link>
              </AnnouncementItem>
            ))
          ) : (
            <AnnouncementPlaceholder colors={colors}>
              No announcements yet. Check back soon for updates.
            </AnnouncementPlaceholder>
          )}
        </AnnouncementList>
      </AnnouncementsMenu>
    </AnnouncementsBlock>
  );
};

export default AnnouncementCard;
